// extracted by mini-css-extract-plugin
export default {"type":"type_type__6Jm7j","text":"type_text__s0VWv","icon":"type_icon__7jj2m"};